"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var useScrollListener = function useScrollListener(element, handleScroll) {
  var throttle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
  var scrollingTimer = (0, _react.useRef)();
  var listenToScroll = (0, _react.useCallback)(function (e) {
    window.removeEventListener('scroll', listenToScroll);
    scrollingTimer.current && clearTimeout(scrollingTimer.current);
    scrollingTimer.current = setTimeout(function () {
      return window.addEventListener('scroll', listenToScroll);
    }, throttle);
    handleScroll(e);
  }, [throttle, handleScroll]);
  (0, _react.useEffect)(function () {
    var currentElement = element;

    if (currentElement) {
      window.addEventListener('scroll', listenToScroll);
    }

    return function () {
      window.removeEventListener('scroll', listenToScroll);
      scrollingTimer.current && clearTimeout(scrollingTimer.current);
    };
  }, [listenToScroll, element]);
};

var _default = useScrollListener;
exports["default"] = _default;
//# sourceMappingURL=useScroll.js.map